import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	InputAdornment,
	Switch,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { cloneDeep, isEqual } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { getApartmentList, updateFacility } from '../../actions/facilities/facilities.actions'
import { showError, showSuccess } from '../../actions/misc/misc.actions'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'
import SpecialDayPassPricingSetup from './Settings/SpecialDayPassPricingSetup'
import SpecialDayPassPricingTable from '../../components/Tables/SpecialDayPassPricingTable'
import { api } from '../../services/api'
import { onlyNumbers, formatNumsToDollars } from '../../utils'
import { facilityOffersBarPark } from '../../utils/barPark'

const useStyles = makeStyles((theme) => ({
	root: {
		// flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '10px !important'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	},
	switchRoot: {
		width: 42,
		height: 26,
		padding: 0
	},
	switchBase: {
		padding: 1,
		'&$checked': {
			transform: 'translateX(16px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1,
				border: 'none'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 24,
		height: 24
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(['background-color', 'border'])
	},
	checked: {},
	focusVisible: {},
	bottomBar: {
		position: 'fixed',
		bottom: 0,
		width: '100%',
		height: 60,
		background: '#FFF',
		borderTop: '1px solid #E5E5E5',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		padding: 20,
		zIndex: 10000,
		left: 0,
		boxShadow: '0px -3px 10px rgba(0,0,0,0.1)',
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35'
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		}
	}
}))

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

const BarParkSettings = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const [localLoading, setLocalLoading] = useState(false)

	const loading = useSelector((state) => state.specific.facilities.loading) || localLoading

	const [current, setCurrent] = useState(null)
	const [daypass_prices, setDayPassPrices] = useState({})
	const [isSaveShown, setIsSaveShown] = useState(false)
	const [changed, setChanged] = useState(false)
	const [specialDayPassPrice, setSpecialDayPassPrice] = useState(null)

	useEffect(() => {
		if (params.facilityId && selectedFacility) {
			setCurrent(cloneDeep(selectedFacility))
			setDayPassPrices(selectedFacility.daypass_prices)
			dispatch(getApartmentList(selectedFacility.market_id))
		}
	}, [params.facilityId, selectedFacility])

	useEffect(() => {
		if (current && selectedFacility) {
			let facilityEqual = !isEqual(current, selectedFacility)

			setIsSaveShown(facilityEqual)
		}
	}, [current, selectedFacility])

	const saveSelectedFacility = () => {
		let updates = { bar_park_open: current.bar_park_open }
		dispatch(updateFacility(selectedFacility._id, updates))
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(selectedFacility))
	}

	const renderDialogText = () => {
		if (current.bar_park_open)
			return 'Once confirmed, clients will be able to check into the Bar & Park until this setting is disabled'
		return 'Once confirmed, clients will no longer be able to check into the Bar & Park until this setting is enabled'
	}

	const updatePrice = (day, type, price) => {
		const new_prices = {
			...daypass_prices,
			[day]: {
				...daypass_prices[day],
				[type]: parseInt(onlyNumbers(price))
			}
		}

		setDayPassPrices(new_prices)
		setChanged(true)
	}

	const save = async () => {
		try {
			setLocalLoading(true)
			const { data } = await api.put(`/facilities/dayPassPrices/${selectedFacility._id}`, daypass_prices)
			console.log('data...', data)
			dispatch(showSuccess('Prices Updated'))
			dispatch({ type: 'UPDATE_FACILITY_SUCCESS', payload: { ...selectedFacility, daypass_prices } })
			setLocalLoading(false)
			setChanged(false)
		} catch (e) {
			setLocalLoading(false)
			dispatch(showError('Error Updating Prices'))
			console.log('big ol e...', e)
		}
	}

	const cancel = () => {
		setDayPassPrices(selectedFacility.daypass_prices)
		setChanged(false)
	}

	if (selectedFacility && !facilityOffersBarPark(selectedFacility)) {
		return (
			<Container className={classes.root} maxWidth="auto">
				<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
					Bar & Park Settings
				</Typography>
				<Card style={{ maxWidth: '1245px' }}>
					<CardContent>
						<Typography variant="body2" color="textSecondary">
							{selectedFacility.name} does not offer Bar & Park. It is enabled per facility
							(services.bar_park.available); there is nothing to configure here until it is.
						</Typography>
					</CardContent>
				</Card>
			</Container>
		)
	}

	return (
		<div>
			{current ? (
				<Container className={classes.root} maxWidth="auto">
					<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
						Bar & Park Settings
					</Typography>
					<Card style={{ maxWidth: '1245px' }}>
						<CardHeader title="Client Check In" />
						<CardContent>
							<div
								style={{
									display: 'flex',
									width: '353px',
									backgroundColor: '#F9F9F9',
									borderRadius: '6px',
									alignItems: 'center',
									justifyContent: 'space-between',
									paddingRight: '16px'
								}}>
								<Typography
									style={{
										padding: '16px',
										fontWeight: '800',
										fontSize: '16px'
									}}>
									Check In Availibility
								</Typography>
								<Switch
									checked={current.bar_park_open}
									onChange={() => {
										setCurrent({ bar_park_open: !current.bar_park_open })
									}}
									name="checkInsAvailable"
									classes={{
										root: classes.switchRoot,
										switchBase: classes.switchBase,
										thumb: classes.thumb,
										track: classes.track,
										checked: classes.checked
									}}
									inputProps={{ 'aria-label': 'secondary checkbox' }}
								/>
							</div>
						</CardContent>
					</Card>
					<SpecialDayPassPricingSetup
						setLocalLoading={setLocalLoading}
						specialDayPassPrice={specialDayPassPrice}
						setSpecialDayPassPrice={setSpecialDayPassPrice}
					/>
					<SpecialDayPassPricingTable
						setLocalLoading={setLocalLoading}
						setSpecialDayPassPrice={setSpecialDayPassPrice}
					/>
					<Card style={{ maxWidth: '1245px' }}>
						<CardHeader title="Day Pass Pricing" />
						<CardContent>
							<div style={{}}>
								{days.map((d) => {
									return (
										<Card
											key={`card-${d}`}
											style={{
												padding: 24,
												marginBottom: 16,
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
												alignItems: 'center'
											}}>
											<Typography
												style={{
													fontWeight: '800',
													fontSize: '16px'
												}}>
												{d}
											</Typography>
											<div>
												<TextField
													id="time-select"
													variant="filled"
													label="Day Pass Price"
													value={
														daypass_prices[d]
															? formatNumsToDollars(
																	onlyNumbers(daypass_prices[d].day_pass_price)
															  )
															: ''
													}
													onChange={(e) =>
														updatePrice(d, 'day_pass_price', e.target.value)
													}
													style={{
														marginRight: 16,
														width: 340,
														maxWidth: 340,
														minWidth: 340
													}}
													InputProps={{
														style: {
															width: 340,
															maxWidth: 340
														},
														startAdornment: (
															<InputAdornment
																className={classes.currencyAdornment}
																position="start">
																$
															</InputAdornment>
														)
													}}
												/>
												<TextField
													id="time-select"
													variant="filled"
													label="Additional Dog Price"
													value={
														daypass_prices[d]
															? formatNumsToDollars(
																	onlyNumbers(
																		daypass_prices[d].additional_pet_price
																	)
															  )
															: ''
													}
													onChange={(e) =>
														updatePrice(d, 'additional_pet_price', e.target.value)
													}
													style={{
														marginRight: 16,
														width: 340,
														maxWidth: 340,
														minWidth: 340
													}}
													InputProps={{
														style: {
															width: 340,
															maxWidth: 340
														},
														startAdornment: (
															<InputAdornment
																className={classes.currencyAdornment}
																position="start">
																$
															</InputAdornment>
														)
													}}
												/>
											</div>
										</Card>
									)
								})}
							</div>
						</CardContent>
					</Card>
					{changed ? (
						<div className={classes.bottomBar}>
							<Button
								variant="outlined"
								onClick={cancel}
								color="secondary"
								style={{
									marginRight: 16
								}}>
								Cancel
							</Button>
							<Button variant="contained" onClick={save} color="secondary">
								Apply
							</Button>
						</div>
					) : null}
					<Dialog
						open={isSaveShown}
						className={classes.dialog}
						onClose={() => {
							setIsSaveShown(false)
							clearChanges()
						}}
						PaperProps={{
							style: {
								minWidth: '448px',
								maxWidth: '448px',
								width: '448px'
							}
						}}>
						<DialogTitle
							style={{
								marginBottom: 24
							}}>
							{current.bar_park_open ? 'ENABLING ' : 'DISABLING '}CLIENTS ABILITY TO CHECK IN
						</DialogTitle>
						<DialogContent>
							<Typography
								variant="body2"
								style={{
									marginBottom: 24
								}}>
								{renderDialogText()}
							</Typography>
						</DialogContent>
						<DialogActions className={classes.dialogActions}>
							<Button variant="contained" onClick={() => saveSelectedFacility()} color="secondary">
								CONFIRM
							</Button>
							<Button
								variant="outlined"
								onClick={() => {
									clearChanges()
									setIsSaveShown(false)
								}}
								color="secondary">
								CANCEL
							</Button>
						</DialogActions>
					</Dialog>
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default BarParkSettings
